'use client';

import { useMemo } from 'react';

import { useSearchParams } from 'next/navigation';

import {
  buildTrackingParams,
  readFbCookies,
  type TrackingParams,
} from './tracking-params';

/** TrackingParams + the Meta cookies + the experiment variant. */
export interface FullTrackingParams extends TrackingParams {
  fbp?: string;
  fbc?: string;
  experimentVariant?: string;
}

/**
 * The full tracking block (UTM + click-ids + `_fbp`/`_fbc` cookies + experiment
 * variant) for the landing lead forms that submit all of it — `inline-lead-form`
 * and `chatbot-lead-overlay` carried byte-identical copies of this. Forms that
 * submit only a subset (e.g. spitex: params only) use `buildTrackingParams`
 * directly instead, so this hook never widens what they send.
 */
export function useTrackingParams(
  experimentVariant?: string,
): FullTrackingParams {
  const searchParams = useSearchParams();
  return useMemo(
    () => ({
      ...buildTrackingParams((key) => searchParams.get(key)),
      ...readFbCookies(),
      experimentVariant: experimentVariant ?? undefined,
    }),
    [searchParams, experimentVariant],
  );
}
